import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4285a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

import { ref, watch } from "vue";

// props
interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  selectWidth?: string;
  // -------------------
  initialData: string | number; // 初期値
  title: string;
  selectData: { label: string; value: string | number }[]; // selectボックス用データ
}

export default /*#__PURE__*/_defineComponent({
  __name: 'searchSelect',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    selectWidth: {},
    initialData: {},
    title: {},
    selectData: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "15cedcb9": (_ctx.titleMaxWidth !== undefined?_ctx.titleMaxWidth : "90px"),
  "6d111f31": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "8b374c90": (props.listMinWidth !== undefined?props.listMinWidth : "224px"),
  "6049d114": (props.selectWidth !== undefined?props.selectWidth : 'initial')
}))

const props = __props;
// emit
const emit = __emit;

const selectedValue = ref("" as string | number);
// 初期値の格納
watch(
  () => props.initialData,
  () => {
    if (props.initialData !== undefined) {
      selectedValue.value = props.initialData;
    }
  },
  { immediate: true }
);
const chengeSelect = (e: Event) => {
  if (!(e.target instanceof HTMLSelectElement)) throw new TypeError();
  selectedValue.value = e.target.value;
  emit("change", selectedValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        onChange: chengeSelect,
        value: selectedValue.value,
        class: _normalizeClass({ Select_Width: props.selectWidth !== undefined })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectData, (option, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: index
          }, _toDisplayString(option.label), 9, _hoisted_5))
        }), 128))
      ], 42, _hoisted_4)
    ])
  ]))
}
}

})